import React from 'react'
import VerifyCodeForm, {
  OnFailure,
  OnResendCodeSuccess,
  OnResendCodeError,
} from '../../components/forms/verify-code'
import {
  makeResendCode,
  makeValidateCode,
  ValidateCodeError,
} from '../../lib/apiService'
import useLogger from '../../lib/logger/use-logger'
import useNotifications from '../../lib/notifications/use-notifications'
import OnboardingPage from '../onboarding-page'

interface Props {
  email: string
  actionName: string
}

const VerifyCodePage: React.FC<Props> = (props) => {
  const logger = useLogger()
  const { setNotification, clearNotifications } = useNotifications()

  const onFailure: OnFailure = (data) => {
    data.errors.forEach((err) => {
      switch (err) {
        case ValidateCodeError.TooManyAttempts:
          setNotification({
            id: 'verify-code-page/on-failure-too-many-attempts',
            type: 'failure',
            message:
              'This account has been blocked after too many failed attempts. Please contact Customer Support.',
          })
          break
        default:
          setNotification({
            id: 'verify-code-page/on-failure',
            type: 'failure',
            message:
              'There was a problem loading this information. Please try again.',
          })
      }
    })
  }

  const onResendCodeSuccess: OnResendCodeSuccess = () => {
    setNotification({
      id: 'verify-code-page/on-resend-code-success',
      type: 'success',
      message: 'Verification code has been re-sent',
    })
  }

  const onResendCodeError: OnResendCodeError = () => {
    setNotification({
      id: 'verify-code-page/on-resend-code-error',
      type: 'failure',
      message: 'If you do not receive your code shortly, please try again',
    })
  }

  const validateCode = makeValidateCode({ logger })
  const resendCode = makeResendCode({ logger })

  return (
    <OnboardingPage>
      <VerifyCodeForm
        email={props.email}
        actionName={props.actionName}
        onFailure={onFailure}
        onResendCodeSuccess={onResendCodeSuccess}
        onResendCodeError={onResendCodeError}
        validateCode={(...args) => {
          clearNotifications()
          return validateCode(...args)
        }}
        resendCode={(...args) => {
          clearNotifications()
          return resendCode(...args)
        }}
      />
    </OnboardingPage>
  )
}

export default VerifyCodePage
